import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurationAppV2 } from 'smartsuite-configuration-app';
import {
    getDataPromise,
    postDataPromise,
    putDataPromise,
} from 'brock-fetch-utils';
import configuration from './data/configuration';
import { configBuilder } from './utils/configBuilder';
import {
    buildChangesToSave,
    buildStateFromApiCall,
} from './utils/notificationUtils';
import { uriConstants } from '../../constants/ConfigurationConstants';
import useFavorite from '../../../../hooks/useFavorite';
import getCurrentLanguage from '../../../../utils/getCurrentLanguage';
import getUri from '../../../../utils/getUri';
import templates from './data/instances';

/* eslint-disable no-console */
const actions = {
    getLayoutConfiguration: async () => {
        const instances = await getDataPromise(
            uriConstants.getNotificationInstancesUri
        );
        return configBuilder(configuration, JSON.parse(instances), templates);
    },

    getData: async () => {
        const initialDataString = await getDataPromise(
            uriConstants.getNotificationInstancesUri
        );
        const initialData = JSON.parse(initialDataString);
        const configurationAppData = buildStateFromApiCall(initialData);

        console.log({ getData: { initialData, configurationAppData } });
        return [initialData, configurationAppData];
    },

    getSelectOptions: async (selectOptionKeys) => {
        const selectOptions = await postDataPromise(
            uriConstants.selectOptionsUri,
            selectOptionKeys
        );

        console.log({ getSelectOptions: selectOptions });
        return selectOptions;
    },

    saveData: async (changes, initialData) => {
        console.log({ saveData: { changes, initialData } });

        return putDataPromise(
            getUri('ManageNotificationInstance'),
            JSON.stringify(buildChangesToSave(changes, initialData))
        );
    },

    add: {
        fields: [
            {
                id: 'newSectionName',
                label: 'Notification',
                inputType: 'string',
            },
            {
                id: 'newSectionInstanceType',
                label: 'Notification Type',
                inputSelectOptionKey: 'notificationInstanceType',
                inputType: 'singleSelect',
            },
        ],
        callback: (fields) => {
            console.log({ add: { fields } });

            const [sectionNameField, sectionInstanceTypeField] = fields;

            return postDataPromise(
                uriConstants.createNotificationUri,
                JSON.stringify({
                    name: sectionNameField.value,
                    type: sectionInstanceTypeField.value,
                    isActive: false,
                })
            );
        },
    },
    delete: {
        callback: (id) => {
            console.log({ delete: { id } });

            return postDataPromise(
                uriConstants.deleteNotificationInstanceUri,
                JSON.stringify(id)
            );
        },
    },
    clone: {
        callback: (id, name) => {
            console.log({ clone: { id, name } });

            return postDataPromise(
                uriConstants.cloneNotificationInstanceUri,
                JSON.stringify({ id, name })
            );
        },
    },
};

export default function AppWrapper() {
    const { i18n } = useTranslation('configuration');
    const favoriteUtilities = useFavorite();

    const resourceData = i18n.getDataByLanguage(getCurrentLanguage());

    return (
        <ConfigurationAppV2
            actions={actions}
            labels={{ configurationLabels: resourceData.configuration }}
            favoriteUtilities={favoriteUtilities}
            uriConstants={uriConstants}
        />
    );
}
